import { useCurrentUser } from 'hooks/useCurrentUser'
import { useSubscriptions } from 'hooks/useSubscriptions'

import { Program } from 'types/program'
import { UserType } from 'types/user'

export const useOtherMembers = (program: Program | undefined) => {
  const { data: currentUser } = useCurrentUser()
  const { data: subscribedUsers, isLoading } = useSubscriptions({
    trainerId: program?.trainer.id,
  })

  const removeDuplicates = (data: UserType[] | undefined) => {
    const uniqueIds: string[] = []
    return data?.filter((item) => {
      const userId = item.id as string
      if (!uniqueIds.includes(userId)) {
        uniqueIds.push(userId)
        return true
      }
      return false
    })
  }

  let members = subscribedUsers
    ?.map((sub) => sub.user)
    .filter((item) => item.id !== currentUser?.id)
  members = removeDuplicates(members)

  return {
    data: program ? members : [],
    isLoading,
  }
}
